<app-relatorio-container
    tituloRelatorio="Termo de Definição de Prazo"
    descricaoRelatorio="Termo de compromisso de entrega de documentação pendente (120 dias)."
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'termo-definicao-prazo-pj.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6">
            <p class="text-sm text-color-secondary m-0">O termo é emitido para o prestador selecionado, utilizando os dados do diretor técnico cadastrado. Nenhum filtro adicional é necessário.</p>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Termo" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
